module.exports = require("core-js/library/fn/array/from");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/array/from.js
// module id = 43
// module chunks = 0 1 3